import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FurnitureComponent } from './furniture.component';

const routes: Routes = [
  {
    path: '',
    component: FurnitureComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('../furniture/applicant/furniture-applicant.module').then(
            (m) => m.FurnitureApplicantModule
          ),
      },
      {
        path: 'employer',
        loadChildren: () =>
          import(
            '../furniture/applicant-employer/furniture-applicant-employer.module'
          ).then((m) => m.FurnitureApplicantEmployerModule),
      },
      {
        path: 'confirmation',
        loadChildren: () =>
          import(
            '../furniture/confirmation/furniture-confirmation.module'
          ).then((m) => m.FurnitureConfirmationModule),
      },
    ],
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FurnitureRoutingModule {}
